import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { connect } from 'react-redux';
import {
  isExperimentOn,
  primaryColorOrDefault,
  textColorOrDefault,
} from '../../reducers';
import utils from '../../services/utils';
import { BACKGROUND_OPACITY, COLOR_OPACITY } from '../../constants/branding';
import { EditorViewMode } from '../../constants/editor-view-mode';
import styles from './Branding.scss';
import { UoUAscendBrandingNew, getPackagePickerUrl } from './Brandings';
import { Popover, Button } from 'wix-style-react';
import i18next from 'i18next';

export interface BrandingProps {
  i18nData: any;
  color: string;
  background: string;
  viewMode: EditorViewMode;
  isAscendNewPPExperimentOn: boolean;
}

export interface BrandingState {
  isBrandingPopupUpgradeShown: boolean;
}

class Branding extends React.Component<BrandingProps, BrandingState> {
  constructor(props) {
    super(props);

    this.state = {
      isBrandingPopupUpgradeShown: false,
    };
  }

  render = () => {
    const {
      i18nData,
      color,
      background,
      viewMode,
      isAscendNewPPExperimentOn,
    } = this.props;

    return (
      <I18nextProvider i18n={i18nData}>
        <div
          style={{ background, color }}
          className={styles.branding}
          data-hook="branding"
        >
          {viewMode === EditorViewMode.PREVIEW ? (
            <div>
              <Popover
                animate
                appendTo="window"
                flip
                shown={this.state.isBrandingPopupUpgradeShown}
                placement="top"
                showArrow
                onMouseEnter={() =>
                  this.setState({
                    isBrandingPopupUpgradeShown: true,
                  })
                }
                onMouseLeave={() =>
                  this.setState({ isBrandingPopupUpgradeShown: false })
                }
                dataHook={'branding-popup'}
                moveArrowTo={20}
              >
                <Popover.Element>
                  <UoUAscendBrandingNew
                    isAscendNewPP={isAscendNewPPExperimentOn}
                  />
                </Popover.Element>
                <Popover.Content>
                  <div className={styles.upgradePopup}>
                    <div
                      className={styles.upgradePopupText}
                      data-hook="branding-popup-text"
                    >
                      {i18next.t('branding.preview-branding-ascend')}
                    </div>
                    <div className={styles.upgradePopupButton}>
                      <Button
                        skin="premium"
                        size="tiny"
                        as="a"
                        href={getPackagePickerUrl(isAscendNewPPExperimentOn)}
                        target="_blank"
                        dataHook={'branding-popup-button'}
                      >
                        {i18next.t('branding.upgrade')}
                      </Button>
                    </div>
                  </div>
                </Popover.Content>
              </Popover>
            </div>
          ) : (
            <UoUAscendBrandingNew isAscendNewPP={isAscendNewPPExperimentOn} />
          )}
        </div>
      </I18nextProvider>
    );
  };
}

function mapStateToProps(state) {
  return {
    i18nData: state.i18nData,
    color: utils.getRgbA(textColorOrDefault(state), COLOR_OPACITY),
    background: utils.getRgbA(primaryColorOrDefault(state), BACKGROUND_OPACITY),
    viewMode: state.viewMode,
    isAscendNewPPExperimentOn: isExperimentOn(
      state,
      'specs.market.AscendNewPackagePicker',
    ),
  };
}

export default connect(mapStateToProps)(Branding);
